import { IWebchatIdentity } from 'modules/webchat/domain/entities';

export type TWebchatLifecycleAction =
  | 'none'
  | 'mount'
  | 'show'
  | 'hide'
  | 'reset';

type TResolveWebchatLifecycleActionParams = {
  /** Webchat configurado para a tenância e navegador que não é bot. */
  canLoad: boolean;
  /** Rota em que o chat não aparece (totem, reconhecimento facial etc.). */
  isBlockedRoute: boolean;
  identity: IWebchatIdentity | null;
  /** Identifier com que o widget foi montado; null se ainda não montou. */
  mountedIdentifier: string | null;
};

export default function resolveWebchatLifecycleAction({
  canLoad,
  isBlockedRoute,
  identity,
  mountedIdentifier,
}: TResolveWebchatLifecycleActionParams): TWebchatLifecycleAction {
  if (!canLoad) return 'none';

  if (mountedIdentifier !== null) {
    if (identity?.identifier !== mountedIdentifier) return 'reset';

    return isBlockedRoute ? 'hide' : 'show';
  }

  if (!identity || isBlockedRoute) return 'none';

  return 'mount';
}
